<template>
    <div class="md-layout md-size-100 md-transparent">
        <div class="md-layout md-layout-nowrap md-size-100 md-alignment-center-left">
            <md-field>
                <label for="txtSearch"><span v-if="title">{{title}}</span><span v-else>Mots de recherche</span></label>
                <md-input id="txtSearch" ref="txtSearch" :value="keywords" @input="onInput" @keyup.enter="search" type="text" />
                <md-button @click="clear" class="md-icon-button">
                    <md-icon>clear</md-icon>
                </md-button>
            </md-field>
            <md-button @click="search" class="md-icon-button md-raised md-primary">
                <md-icon>search</md-icon>
            </md-button>
            <md-button :disabled="expandable == 'disabled'" v-if="expandable || expandable == 'disabled'"
                @click="expand" class="md-icon-button md-raised md-primary">
                <md-icon>filter_alt</md-icon>
            </md-button>
        </div>
        <div class="md-layout md-layout-item md-size-100 ">
            <slot v-if="isExpand"></slot>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
export default {
    name: 'keywordsToolbar',
    props: {
        title: String,
        keywords: String,
        expandable: String,
        },
        data: () => ({
            input: "",
            isExpand: false,
        }),
    methods: {
        search: function () {
            this.$emit('search', this.input);
        },
        onInput: function(e) {
            this.input = e;
            this.$emit('update:keywords', this.input);
        },
        clear: function () {
            if(this.keywords == null) {
                this.$refs.txtSearch.localValue = "";
            }
            this.input = "";
            this.$emit('update:keywords', "");
            this.$emit('search', "");
        },
        expand: function () {
            this.isExpand = !this.isExpand;
            this.$emit('expand', this.isExpand);
        },

    }
}
</script>
